const NamePicker = () => {
  return <div>NamePicker</div>
}

export default NamePicker
